module.exports = __webpack_public_path__ + "static/media/toolbar-q-hideable.b45524ca.svg";